import { render, staticRenderFns } from "./ClientFormSettings.vue?vue&type=template&id=2b472c43&scoped=true&"
import script from "./ClientFormSettings.vue?vue&type=script&lang=ts&"
export * from "./ClientFormSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ClientFormSettings.vue?vue&type=style&index=0&id=2b472c43&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b472c43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VContainer})
